import { useSelector } from 'react-redux';
import { selectErrors } from '../slices/errors';

export const useErrors = () => {
  const { error } = useSelector(selectErrors);

  return error;
};
